import { Box, Grid, Tab, Tabs } from "@mui/material";
import React from "react";
import Purchase from "../purchase/purchase";
import Stocks from "../stocks/stocks";
import { useSelector } from "react-redux";
import FranchiseRequirement from "./ProductDetails";
import CompanyInformation from "./companyInformation";
import ProductDetails from "./ProductDetails";
import AddProduct from "./AddProduct";

export const WhiteLables = ({}) => {
  const [value, setValue] = React.useState("all");
  const [open, setOpen] = React.useState(null);
  const handleChange = (event, newValue) => {
    // setPageNo(1);

    setValue(newValue);
  };
  const businessChooseTab = useSelector(
    (state) => state.reducer.businessChooseTab,
  );

  return (
    <Box>
      <Grid container>
        <Grid item xs={12}>
          {(!businessChooseTab ||
            businessChooseTab?.value == "companyinformation") && (
            <CompanyInformation />
          )}
          {/* {(!businessChooseTab ||
            businessChooseTab?.value == "") && <ProductDetails />} */}

          {businessChooseTab?.value == "productdetails" && (
            <>
              {!open && <ProductDetails setOpen={setOpen} />}
              {open && (
                <AddProduct
                  setOpen={setOpen}
                  //   enquiries={enquiries}
                  backEnquire={() => {
                    // setEnquiries(null);
                  }}
                />
              )}
            </>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};
